module.exports = __webpack_public_path__ + "ebed7581a4931e209d484211d28b36c7.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/eldar-vignette-preview-420.webp
// module id = 272
// module chunks = 0